import { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import { Helmet } from 'react-helmet-async';
import SimpleLayout from '../../layouts/SimpleLayout';

const AboutPage = () => {
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesLoaded = () => {};

    return (
        <>
            <Helmet>
                <title>A propos :: Portail PETROSIL</title>
            </Helmet>

            <div className="page-body">
                <div className="container-xl">
                    <div className="position-relative vh-100 w-100">
                        {init && (
                            <Particles
                                id="tsparticles"
                                particlesLoaded={particlesLoaded}
                                options={{
                                    fpsLimit: 120,
                                    interactivity: {
                                        events: {
                                            onHover: { enable: true, mode: 'repulse' },
                                            resize: true,
                                        },
                                        modes: {
                                            push: { quantity: 4 },
                                            repulse: { distance: 200, duration: 0.4 },
                                        },
                                    },
                                    particles: {
                                        color: { value: '#0d47a1' },
                                        links: { color: '#0d47a1', distance: 150, enable: true, opacity: 0.5, width: 1 },
                                        move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, speed: 1 },
                                        number: { density: { enable: true, area: 800 }, value: 25 },
                                        opacity: { value: 0.5 },
                                        shape: { type: 'circle' },
                                        size: { value: { min: 1, max: 5 } },
                                    },
                                    detectRetina: true,
                                }}
                            />
                        )}

                        <div className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100">
                            <div className="card shadow p-4 text-center" style={{ minWidth: '300px', backgroundColor: 'rgba(255,255,255,0.3)' }}>
                                <h1 className="mb-1">Portail PETROSIL</h1>
                                <small className="text-secondary">© {new Date().getFullYear()} MGM. Tous droits réservés.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

AboutPage.Layout = SimpleLayout;

export default AboutPage;
